import * as angular from "angular";

let MapLocationViewComponent = {
    selector: "vcMapLocationView",
    templateUrl: "/angular/components/map/map-location-view.component.html",
    bindings: {
        location: "=?",
    },
    controller: class MapLocationViewController {
        // * bindings for typescript compiler *
        public location?: any;
        // ************************************

        private $scope: any;
        private uiGmapGoogleMapApi: any;

        public showMap = false;
        public marker: object;
        public map: any;

        constructor($scope: any, $timeout: any, uiGmapGoogleMapApi: any) {
            this.$scope = $scope;
            this.uiGmapGoogleMapApi = uiGmapGoogleMapApi;

            $timeout(() => {
                this.showMap = true;
            }, 500);
        }

        $onInit() {
            if (
                this.location ||
                this.location.latitude ||
                this.location.longitude
            ) {
                this.location.latitude = this.location.latitude || 0;
                this.location.longitude = this.location.longitude || 0;
            }

            let timeoutCode: any;
            this.$scope.$watch(
                () => this.location,
                () => {
                    clearTimeout(timeoutCode);
                    timeoutCode = setTimeout(() => {
                        this.loadMap();
                    }, 200);
                },
                true
            );
        }

        loadMap(): void {
            this.uiGmapGoogleMapApi.then(() => {
                this.map = {
                    bounds: {},
                    center: {
                        latitude: this.location.latitude,
                        longitude: this.location.longitude,
                    },
                    zoom: this.location.latitude == 0 ? 2 : 15,
                    control: {},
                };
                this.initialiseMarker();
            });
        }

        initialiseMarker(): void {
            this.marker = {
                id: 1,
                coords: {
                    latitude: this.location.latitude,
                    longitude: this.location.longitude,
                },
                options: {
                    draggable: false,
                    icon: "/img/map/markers/events.png",
                },
            };
        }
    },
};
angular
    .module("map")
    .component(MapLocationViewComponent.selector, MapLocationViewComponent);
